export class Route {
	airportIata: string;
	airportIcao: string;
	airportId: number;
	dtDeparture: Date[];
}
